export enum TeamDialog {
  Editor,
  Restore,
}
